export default "../css/d35b1572b900b1038abf34effb93ebe5.ttf";